/* Keeps product-card badges (New, Best Seller, Sale...) an equal distance from the top-right corner of the PHOTO,
   in every card type (collection grid, related products, sliders), even when the photo is letterboxed in its frame. */
(function () {
  var INSET = 10;

  function mainImage(badge) {
    // Only ever use a photo inside the badge's OWN card, never one from a neighbouring slide.
    var card = badge.closest('.spf-product-card, .card, .swiper-slide, .slick-slide');
    if (!card) return null;
    var imgs = card.querySelectorAll('img'), k, im, r;
    for (k = 0; k < imgs.length; k++) {
      im = imgs[k];
      if (im.closest('.spf-product__swatchs, .product-card-variant-wrapper')) continue;
      r = im.getBoundingClientRect();
      if (im.naturalWidth > 20 && r.width > 100 && r.height > 100 && getComputedStyle(im).visibility !== 'hidden') return im;
    }
    return null;
  }

  // The rectangle the photo actually occupies inside its <img> box (handles object-fit: contain).
  function photoRect(im) {
    var r = im.getBoundingClientRect();
    if (getComputedStyle(im).objectFit !== 'contain') return r;
    var ar = im.naturalWidth / im.naturalHeight, w = r.width, h = r.height, dw, dh;
    if (ar > w / h) { dw = w; dh = w / ar; } else { dh = h; dw = h * ar; }
    var l = r.left + (w - dw) / 2, t = r.top + (h - dh) / 2;
    return { left: l, top: t, right: l + dw, bottom: t + dh };
  }

  function placeBadge(b) {
    var im = mainImage(b);
    if (!im) return;
    var p = photoRect(im), op = b.offsetParent || b.parentElement, opr = op.getBoundingClientRect();
    // Badges are corner tabs flush with the photo (no inset) on grid cards and on product-slider cards on every page.
    var inset = b.closest('.spf-product-card, .card') ? 0 : INSET;
    b.style.setProperty('top', (p.top - opr.top + inset) + 'px', 'important');
    b.style.setProperty('right', (opr.right - p.right + inset) + 'px', 'important');
    b.style.setProperty('left', 'auto', 'important');
  }

  function placeSoldOut(card) {
    var s = card.querySelector('.spf-product__label-soldout');
    var wrap = card.querySelector('.spf-product-card__image-wrapper');
    if (!s || !wrap) return;
    var im = null, imgs = wrap.querySelectorAll('img'), k;
    for (k = 0; k < imgs.length; k++) { if (imgs[k].offsetWidth > 0 && imgs[k].naturalWidth > 20) { im = imgs[k]; break; } }
    if (!im) return;
    var p = photoRect(im), op = s.offsetParent || card, opr = op.getBoundingClientRect();
    s.style.setProperty('top', (p.top - opr.top + INSET) + 'px', 'important');
    s.style.setProperty('left', (p.left - opr.left + INSET) + 'px', 'important');
    s.style.setProperty('bottom', 'auto', 'important');
  }

  // Discount tab (".sls3-discount-tab"): flush with the photo's top-left corner (no inset).
  function placeTab(tab) {
    var card = tab.closest('.spf-product-card, .card');
    var wrap = card && card.querySelector('.spf-product-card__image-wrapper, .product-img-wrapper');
    if (!wrap) return;
    var im = null, imgs = wrap.querySelectorAll('img'), k;
    for (k = 0; k < imgs.length; k++) { if (imgs[k].offsetWidth > 0 && imgs[k].naturalWidth > 20) { im = imgs[k]; break; } }
    if (!im) return;
    var p = photoRect(im), op = tab.offsetParent || card, opr = op.getBoundingClientRect();
    tab.style.setProperty('top', (p.top - opr.top) + 'px', 'important');
    tab.style.setProperty('left', (p.left - opr.left) + 'px', 'important');
    tab.classList.add('is-placed');
  }

  function run() {
    document.querySelectorAll('.sls3-discount-tab').forEach(placeTab);
    document.querySelectorAll('.product-badge-wrapper').forEach(placeBadge);
    document.querySelectorAll('.spf-product-card').forEach(placeSoldOut);
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(run, 60); }
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') soon(); }, true);
  window.addEventListener('resize', soon);
  // Tab switches (Men/Women etc.) only change classes, so re-place badges after any click
  document.addEventListener('click', function () { setTimeout(soon, 250); }, true);
  document.addEventListener('DOMContentLoaded', function () {
    run();
    new MutationObserver(soon).observe(document.body, { childList: true, subtree: true });
  });
})();


/* Product page tabs: hide paragraphs that are only spaces/&nbsp; (CSS :empty can't catch them) */
(function () {
  function tidy() {
    document.querySelectorAll('tab-content.tab-content p').forEach(function (p) {
      if (!p.textContent.replace(/\u00a0/g, '').trim() && !p.querySelector('img, iframe, video, svg, table')) p.style.display = 'none';
    });
  }
  document.addEventListener('DOMContentLoaded', tidy);
})();

/* SLS3: product grid cards (Globo search + collection) show the Judge.me rating, same as the product page (was Okendo).
   Ratings come from window.SLS3_RATINGS_P (all-products list fetched early in layout/theme.liquid) + a localStorage copy, so stars draw with the card. */
(function(){
  if (window.__sls3JdgmCards) return; window.__sls3JdgmCards = true;
  var KEY = 'sls3JdgmRatings2', map = null, single = {}, pending = {};
  try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && s.r) map = s.r; } catch (e) {}
  var inl = window.SLS3_RATINGS, inlOk = !!(inl && Object.keys(inl).length > 1);
  if (inlOk) { map = map || {}; for (var k in inl) map[k] = inl[k]; }
  function handleOf(card){
    var a = card.querySelector('a[href*="/products/"]'); if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? m[1] : null;
  }
  function render(card, d){
    var old = card.querySelector('.sls3-card-rating'); if (old) old.remove();
    if (!d || !d[1]) return;
    var r = +d[0], c = +d[1], el = document.createElement('div'); el.className = 'sls3-card-rating';
    el.setAttribute('aria-label', 'Rated ' + r.toFixed(1) + ' out of 5 from ' + c + ' reviews');
    el.innerHTML = '<span class="sls3-card-rating__stars" aria-hidden="true"><span class="sls3-card-rating__fill" style="width:' + Math.round(r / 5 * 1000) / 10 + '%"></span></span>'
      + '<span class="sls3-card-rating__count">' + c + (c === 1 ? ' Review' : ' Reviews') + '</span>';
    var title = card.querySelector('.spf-product-card__title');
    if (title && title.parentNode) title.parentNode.insertBefore(el, title.nextSibling);
  }
  function fetchOne(h){
    if (!pending[h]) pending[h] = fetch('/products/' + h + '?view=sls3-rating', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(d){ single[h] = [+d.rating || 0, +d.count || 0]; return single[h]; })
      .catch(function(){ return null; });
    return pending[h];
  }
  function lookup(h){ if (map && map[h]) return map[h]; if (single[h]) return single[h]; return undefined; }
  function scan(full){
    var cards = document.querySelectorAll('.spf-product-card');
    for (var i = 0; i < cards.length; i++) (function(card){
      var h = handleOf(card); if (!h) return;
      var d = lookup(h), sig = h + '|' + (d ? d.join(',') : '');
      if (card.getAttribute('data-sls3-rated') === sig) return;
      if (d !== undefined) { card.setAttribute('data-sls3-rated', sig); render(card, d); return; }
      if (!full) return;
      card.setAttribute('data-sls3-rated', sig);
      fetchOne(h).then(function(x){ if (handleOf(card) === h) { card.setAttribute('data-sls3-rated', h + '|' + (x ? x.join(',') : '')); render(card, x); } });
    })(cards[i]);
  }
  var full = inlOk;
  (window.SLS3_RATINGS_P || Promise.resolve(null)).then(function(r){
    if (r) { map = r; try { localStorage.setItem(KEY, JSON.stringify({t: Date.now(), r: r})); } catch (e) {} }
    full = true; scan(true);
  });
  var queued = false;
  function soon(){ if (queued) return; queued = true; Promise.resolve().then(function(){ queued = false; scan(full); }); }
  scan(false);
  new MutationObserver(soon).observe(document.documentElement, {childList:true, subtree:true});
})();
